import { __decorate } from "tslib";
import React, { cloneElement, Component } from 'react';
import { observer } from 'mobx-react';
import { action, observable, runInAction } from 'mobx';
import isFunction from 'lodash/isFunction';
import omit from 'lodash/omit';
import noop from 'lodash/noop';
import { getProPrefixCls } from 'choerodon-ui/lib/configure';
import Icon from 'choerodon-ui/lib/icon';
import Button from '../../button';
import TableContext from '../TableContext';
import { ButtonColor, FuncType } from '../../button/enum';
import Form from '../../form';
import { $l } from '../../locale-context';
import autobind from '../../_util/autobind';
import { LabelLayout } from '../../form/enum';
import isEmpty from '../../_util/isEmpty';
import { TableQueryBarType } from '../../table/enum';
let TableProfessionalBar = class TableProfessionalBar extends Component {
    constructor() {
        super(...arguments);
        this.openMore = (fields) => {
            if (this.moreFields && this.moreFields.length) {
                this.moreFields = [];
            }
            else {
                this.moreFields = fields;
            }
            return this.moreFields;
        };
    }
    componentDidMount() {
        const { queryFieldsLimit, queryFields, queryDataSet, defaultExpanded } = this.props;
        if (queryDataSet && queryFields.length && defaultExpanded) {
            runInAction(() => {
                this.moreFields = this.createFields(queryFields.slice(queryFieldsLimit));
            });
        }
        this.processDataSetListener(true);
    }
    componentWillUnmount() {
        this.processDataSetListener(false);
    }
    processDataSetListener(flag) {
        const { queryDataSet } = this.props;
        if (queryDataSet) {
            const handler = flag ? queryDataSet.addEventListener : queryDataSet.removeEventListener;
            handler.call(queryDataSet, 'validate', this.handleDataSetValidate);
        }
    }
    /**
     * queryDataSet 查询前校验事件 触发展开动态字段
     * @param dataSet 查询DS
     * @param result
     */
    async handleDataSetValidate({ result }) {
        const { queryFieldsLimit, queryFields } = this.props;
        const moreFields = this.createFields(queryFields.slice(queryFieldsLimit));
        if (!await result) {
            runInAction(() => {
                this.moreFields = moreFields;
            });
        }
    }
    handleFieldEnter() {
        this.handleQuery();
    }
    async handleQuery(collapse) {
        const { dataSet, queryDataSet, onQuery = noop } = this.props;
        if (await queryDataSet?.validate()) {
            await dataSet.query();
            if (!collapse) {
                const queryData = omit(queryDataSet?.current?.toData(true), ['__dirty']);
                const data = Object.keys(queryData).reduce((p, key) => {
                    const value = queryData[key];
                    if (!isEmpty(value)) {
                        p[key] = value;
                    }
                    return p;
                }, {});
                await onQuery({ dataSet, queryDataSet, data });
            }
        }
    }
    getResetButton() {
        const { prefixCls } = this.props;
        return (React.createElement(Button, { key: 'lov_reset_btn', className: `${prefixCls}-professional-reset-btn`, funcType: FuncType.raised, onClick: this.handleQueryReset }, $l('Table', 'reset_button')));
    }
    getMoreFieldsButton(fields) {
        const { prefixCls } = this.props;
        if (fields.length) {
            return (React.createElement(Button, { className: `${prefixCls}-professional-query-more`, funcType: FuncType.raised, onClick: () => this.openMore(fields) },
                $l('Table', 'more'),
                this.moreFields && this.moreFields.length ? React.createElement(Icon, { type: 'expand_less' }) : React.createElement(Icon, { type: 'expand_more' })));
        }
    }
    /**
     * 注入 onEnterDown 事件
     * @param elements
     */
    createFields(elements) {
        return elements.map(element => {
            const { onEnterDown } = element.props;
            if (onEnterDown && isFunction(onEnterDown)) {
                return element;
            }
            const props = {
                onEnterDown: this.handleFieldEnter,
            };
            return cloneElement(element, props);
        });
    }
    getQueryBar() {
        const { prefixCls, queryFieldsLimit, queryFields, queryDataSet, queryFormProps } = this.props;
        if (queryDataSet && queryFields.length) {
            const currentFields = (React.createElement(Form, Object.assign({ dataSet: queryDataSet, columns: queryFieldsLimit, labelLayout: LabelLayout.horizontal }, queryFormProps),
                this.createFields(queryFields.slice(0, queryFieldsLimit)),
                this.moreFields));
            const moreFields = this.createFields(queryFields.slice(queryFieldsLimit));
            const moreFieldsButton = this.getMoreFieldsButton(moreFields);
            return (React.createElement("div", { key: "query_bar", className: `${prefixCls}-professional-query-bar` },
                currentFields,
                React.createElement("span", { className: `${prefixCls}-professional-query-bar-button` },
                    moreFieldsButton,
                    this.getResetButton(),
                    React.createElement(Button, { color: ButtonColor.primary, wait: 500, onClick: () => this.handleQuery() }, $l('Table', 'query_button')))));
        }
    }
    handleQueryReset() {
        const { queryDataSet, onReset = noop } = this.props;
        if (queryDataSet) {
            const { current } = queryDataSet;
            if (current) {
                current.reset();
                onReset();
            }
            this.handleQuery(true);
        }
    }
    render() {
        return this.getQueryBar();
    }
};
TableProfessionalBar.contextType = TableContext;
TableProfessionalBar.defaultProps = {
    prefixCls: getProPrefixCls('performance-table'),
    queryFieldsLimit: 3,
};
TableProfessionalBar.__TableQueryBarType = TableQueryBarType.professionalBar;
__decorate([
    observable
], TableProfessionalBar.prototype, "moreFields", void 0);
__decorate([
    autobind
], TableProfessionalBar.prototype, "handleDataSetValidate", null);
__decorate([
    autobind
], TableProfessionalBar.prototype, "handleFieldEnter", null);
__decorate([
    autobind
], TableProfessionalBar.prototype, "handleQuery", null);
__decorate([
    action
], TableProfessionalBar.prototype, "openMore", void 0);
__decorate([
    autobind
], TableProfessionalBar.prototype, "handleQueryReset", null);
TableProfessionalBar = __decorate([
    observer
], TableProfessionalBar);
export default TableProfessionalBar;
